export default function AppLoading() {
  return (
    <div className="flex min-h-[40vh] w-full items-center justify-center px-4 text-sm text-gray-500">
      กำลังโหลดหน้า...
    </div>
  )
}
